// create a dummy page saying hello to the user
import log from "loglevel";
import React, { useState, useEffect } from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import { Breadcrumb } from "react-bootstrap";
import * as constants from "Constants";
import Alert from "react-bootstrap/Alert";
// import programmingDetails from ProgrammingDetails.jsx';
import ProgrammingDetails from "Screens1/Student/Course/Content/Programming/ComponentsNew/ProgrammingDetails/ProgrammingDetails";
import httpService from "services/httpService";

function SubmitAs() {
  const location = useLocation();

  let defValueOfActivityType = "programming";

  // path : /courseware/course/:courseId/content/labs/:labId/programming/:activityId/submissions/:studentID/submitas
  const { courseId, labId, activityId, studentID } = useParams();

  const [activityType, setActivityType] = useState(defValueOfActivityType);

  const [ProgrammingActivityDetails, setProgrammingActivityDetails] =
    useState(null);
  const [AccessControlsProgActivity, setAccessControlsProgActivity] =
    useState(null);

  const [otherActivityDetails, setOtherActivityDetails] = useState(null);

  const [activity_title, setActivityTitle] = useState(
    location.state.activityTitle
  );
  const [labTitle, setLabTitle] = useState(location.state.labTitle);
  const [labAvailableTill, setAvailableTill] = useState(
    location.state.available_till
  );
  const [activity_description, setActivityDescription] = useState("");
  const [roll, setRoll] = useState(location.state.roll);
  const [name, setName] = useState(location.state.name);

  useEffect(() => {
    log.log("Program Class Component Student Side");
    log.log("program data ", ProgrammingActivityDetails);
    // print all location details
    log.log("Location Details ", location.state);
    log.log("Lab ID ", labId);
  }, []);

  useEffect(() => {
    log.log("Inside UsedEffect Outside IF Block", activityId);
    log.log("calling useeffect for", activityId);

    if (activityId) {
      log.log("activityId inside Activity Container ", activityId);
      var url =
        constants.base_url +
        "/lab/activity/" +
        activityId +
        "?type=" +
        activityType;

      log.log("Get Activity URL ", url);

      const getProgramDetail = async ()=>{
      try{
        const response = await httpService.get(url);
        log.log("Activity Response Details ", response);
  
        if (activityType === "programming") {
          setProgrammingActivityDetails(response.data?.program_data);
          setAccessControlsProgActivity(response.data?.access_control_vars);
          setActivityDescription(response.data?.program_data?.description);
          setActivityTitle(response.data?.program_data?.name);
        } else if (activityType === "virtual") {
        } else if (activityType === "other") {
          setOtherActivityDetails(response.data?.other_activity);
        }
      }
      catch(error){
        log.error(error);
      }
    }
    getProgramDetail();
  }
  }, [activityId, activityType]);

  useEffect(() => {
    if (labId) {
      var url = constants.base_url + "/lab/all/" + labId;
      const fetchLabDetail = async()=>{
        try{
          const response = await httpService.get(url,{
            params: {
              courseId,
            }
          });
          setLabTitle(response.data.lab.title);
        }
        catch(error)  {
              log.log(error);
              log.log("Error in getting the lab title");
        }
      }
      fetchLabDetail();
    }
    
  }, [labId]);

  const changeAccess = (update) => {
    //updating access control variables
    setAccessControlsProgActivity(update);
  };

  return (
    <div className="container my-2">
      <Breadcrumb>
        <Breadcrumb.Item href="#">
          <Link to={`/courseware/course/${courseId}/content/labs`}>Labs</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item href="#">
          <Link to={`/courseware/course/${courseId}/content/labs/${labId}/`}>
            {labTitle}
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item href="#">
          <Link
            to={`/courseware/course/${courseId}/content/labs/${labId}/${activityType}/${activityId}/submissions`}
          >
            Submissions
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item active>
          {activity_title} / {name} {"(" + roll + ")"}
        </Breadcrumb.Item>
      </Breadcrumb>
      <div>
        <Alert
          show={true}
          variant="info"
        >
          You are submitting as {name} {"(" + roll + ")"}
        </Alert>

        <ProgrammingDetails
          programId={activityId}
          activity_title={activity_title}
          activity_description={activity_description}
          details={ProgrammingActivityDetails}
          changeAccess={changeAccess}
          access={AccessControlsProgActivity}
          delegate_student_id={studentID}
        />
      </div>
    </div>
  );
}
export default SubmitAs;
